module.exports = __webpack_public_path__ + "static/media/administration_accounts.6d8a0533.svg";